import React, { useEffect, useState } from "react";
import "./styles.scss";
import { AdCategoryCard, FormHeader, JobCategoryCard } from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { CreateNewJobsCategory } from "../CreateNewItem";
import { getLanguage } from "../../utils/environment";
import Scrollbars from "react-custom-scrollbars-2";
import { useDispatch, useSelector } from "react-redux";
import { setJobCategory, setJobCategoryList } from "../Jobs/redux/actions";
import {
  deleteJobCategory,
  getAllJobsCategory,
} from "../CreateNewItem/CreateNewJob/service/jobs.service";
import { Store } from "react-notifications-component";

const lan = getLanguage();

const JobsCategory = () => {
  const dispatch = useDispatch();
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [selectjobCategory, setSelectjobCategory] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const jobCategoryList = useSelector(
    (state) => state.jobsReducer.jobCategoryList
  );

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const getList = await getAllJobsCategory();
      console.log("Get All Jobs Category : ", getList);

      if (getList?.data) {
        dispatch(setJobCategoryList(getList.data));
      } else {
        console.log("Data Not Found");
      }
    } catch (error) {
      console.log("Error fetching Data", error);
    }
  };

  return (
    <>
      <div className="hne-jb-category-wrapper">
        <div className="col-9 jb-category-body-wrapper">
          <FormHeader
            data={{
              formHeader: "Jobs Category",
              size: "md-md",
            }}
          />
          <div className="hne-jb-cetgory-header-wrapper">
            <div className="jchw-id">Id</div>
            <div className="jchw-category">Jobs Category </div>
          </div>
          <div className="hne-jb-category-body-wrapper">
            <Scrollbars
              onScroll={handleOnScroll}
              renderView={(props) => (
                <div
                  {...props}
                  style={{ ...props.style, overflowX: "hidden" }}
                />
              )}
              style={{ height: viewPointHeight - 218 }}
            >
              <div className={"hne_job-category-wrapper "}>
                {Array.isArray(jobCategoryList) &&
                jobCategoryList.length > 0 ? (
                  jobCategoryList.map((category) => (
                    <JobCategoryCard
                      isSelect={selectjobCategory === category?.job_category_id}
                      logo={category.logo}
                      id={category.job_category_id}
                      name={category.jobs_category_name}
                      edit="Edit"
                      delete="Delete"
                      onClickEdit={() => {
                        setSelectjobCategory(category?.job_category_id);
                        dispatch(setJobCategory(category));
                      }}
                      onClickRemove={async (e) => {
                        setIsLoading(true);
                        try {
                          let result = await deleteJobCategory(
                            category?.job_category_id
                          );
                          console.log("Delete Job Category Result: ", result);
                          if (result?.data) {
                            Store.addNotification({
                              title: "Success",
                              message: "Job category deleted successfully",
                              type: "success",
                              container: "top-right",
                              dismiss: {
                                duration: 2000,
                                onScreen: true,
                              },
                            });
                            await fetchData();
                          }
                        } catch (error) {
                          console.log("Error deleting Job Category", error);
                          Store.addNotification({
                            title: "Error",
                            message: "Failed to delete job category",
                            type: "danger",
                            container: "top-right",
                            dismiss: {
                              duration: 2000,
                              onScreen: true,
                            },
                          });
                        }
                      }}
                    />
                  ))
                ) : (
                  <div className="error-message">No Category Found</div>
                )}
              </div>
            </Scrollbars>
          </div>
        </div>

        {/*right side*/}
        <div className="col-3 jb-category-right-side-wrapper">
          <CreateNewJobsCategory refresh={fetchData} />
        </div>
      </div>
    </>
  );
};
export default withRouter(JobsCategory);
